export const CARD_TEMPLATES_KEY = 'cardTemplates'
